import { useState, type FormEvent } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { signIn } from '../lib/auth.js';

export function LoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    const result = await signIn(email, password);
    setSubmitting(false);
    if (result.ok) {
      navigate({ to: '/dashboard' });
    } else {
      setError(result.error ?? 'Sign-in failed');
    }
  }

  return (
    <main className="max-w-md mx-auto px-6 py-16">
      <h1 className="text-3xl font-semibold text-brand-primary mb-6">Sign in</h1>
      <form onSubmit={onSubmit} className="space-y-4" noValidate>
        <label className="block">
          <span className="block text-sm font-medium text-brand-body mb-1">Email</span>
          <input
            type="email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="input"
            required
          />
        </label>
        <label className="block">
          <span className="block text-sm font-medium text-brand-body mb-1">Password</span>
          <input
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="input"
            required
          />
        </label>

        {error && (
          <p className="text-red-700 text-sm bg-red-50 border border-red-200 rounded p-3">
            {error}
          </p>
        )}

        <button
          type="submit"
          disabled={submitting || !email || !password}
          className="w-full bg-brand-accent hover:brightness-95 disabled:opacity-60 text-white px-8 py-3 rounded-md font-medium transition"
        >
          {submitting ? 'Signing in...' : 'Sign in'}
        </button>
      </form>
      <p className="text-sm text-brand-muted mt-6">
        New here? Start an{' '}
        <a className="underline" href="/onboarding/start">
          onboarding application
        </a>
        .
      </p>
    </main>
  );
}
